import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Root = styled(Box)({
  minWidth: 0,
  overflow: "hidden",
});

export const Viewport = styled(Box, {
  shouldForwardProp: (prop) => prop !== "$height",
})<{ $height: number }>(({ $height }) => ({
  position: "relative",
  height: $height,
  overflow: "hidden",
}));

export const Loading = styled(Box)({
  position: "absolute",
  inset: 0,
  zIndex: 2,
});

// Sits beside the scaled box, not inside it: the one message that explains why
// the preview is gone has to stay readable however small the preview is.
export const Fallback = styled(Box)(({ theme }) => ({
  position: "absolute",
  inset: 0,
  zIndex: 3,
  backgroundColor: theme.palette.background.paper,
}));

export const Scaled = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== "$scale" && prop !== "$width" && prop !== "$height",
})<{ $scale: number; $width: number; $height: number }>(
  ({ $scale, $width, $height }) => ({
    position: "relative",
    width: $width,
    height: $height,
    overflow: "hidden",
    ...($scale !== 1 && {
      transform: `scale(${$scale})`,
      transformOrigin: "top left",
    }),
  })
);

// The frame that is not on screen stays fully visible to the renderer and is
// covered by Mask instead: an opacity-0 or hidden iframe is not rasterised at
// all, so revealing one means watching the page paint itself.
export const Frame = styled("iframe", {
  shouldForwardProp: (prop) => prop !== "$front",
})<{ $front: boolean }>(({ $front }) => ({
  position: "absolute",
  top: 0,
  left: 0,
  display: "block",
  border: "none",
  zIndex: $front ? 2 : 0,
  pointerEvents: $front ? "auto" : "none",
}));

export const Mask = styled(Box)(({ theme }) => ({
  position: "absolute",
  inset: 0,
  zIndex: 1,
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.background.paper,
}));

export const ScaleNote = styled(Typography)(({ theme }) => ({
  display: "block",
  marginTop: theme.spacing(0.75),
  fontSize: 11,
  color: theme.palette.text.disabled,
}));
